import React from 'react';
import { useEffect, useRef, useState } from 'react'
import {
  SDrawerOrModal,
} from 'shj-components'
import { Row, Col, Select, Switch, Button, message } from 'antd';
import {
  queryContractInfoDetail,
} from '@/services/goods.ts';
import styles from './index.module.less'

export default function DetailModal ({ editId = '', open = false, onClose = () => {} })  {

  const [contentInfo, setContentInfo] = useState({});

  useEffect(() => {
    if (editId) {
      getDetail(editId);
    }
  }, [editId]);

  const getDetail = async (id) => {
    try {
      const res: any = await queryContractInfoDetail(id);
      if (res?.id) {
        setContentInfo(res);
      }
    } catch(err) {
      console.log(err)
    }
  }

  return (
    <div className={styles.detailModalBox}>
      <SDrawerOrModal
        title='详情'
        mode="drawer"
        open={open}
        onCancel={() => onClose()}
        antdProps={{
          footer: ''
        }}
        width="60%"
        isHideCancelBtn={true}
        okBtnDisabled={true}
      >
        <Row gutter={[15, 10]} className={styles.rowBox}>
          <Col span={12} className={styles.colBox}>
            <span className={styles.titleBox}>合同标题：</span>
            <span className={styles.content}>{ (contentInfo as any)?.title }</span>
          </Col>
          <Col span={12} className={styles.colBox}>
            <span className={styles.titleBox}>报价类型：</span>
            <span className={styles.content}>{ (contentInfo as any)?.quoteTypeName }</span>
          </Col>
        </Row>
        <Row gutter={[15, 10]} className={styles.rowBox}>
          <Col span={12} className={styles.colBox}>
            <span className={styles.titleBox}>合同类型：</span>
            <span className={styles.content}>{ (contentInfo as any)?.contractTypeName }</span>
          </Col>
          <Col span={12} className={styles.colBox}>
            <span className={styles.titleBox}>是否在线模板：</span>
            <span className={styles.content}>{ (contentInfo as any)?.onlineFlag ? '是' : '否' }</span>
          </Col>
        </Row>
        <Row gutter={[15, 10]} className={styles.rowBox}>
          <Col span={12} className={styles.colBox}>
            <span className={styles.titleBox}>关联的合同模板：</span>
            <span className={styles.content}>{ (contentInfo as any)?.printTemplateName }</span>
          </Col>
          <Col span={12} className={styles.colBox}>
            <span className={styles.titleBox}>合同是否需审核：</span>
            <span className={styles.content}>{ (contentInfo as any)?.auditFlag ? '是' : '否' }</span>
          </Col>
        </Row>
        <Row gutter={[15, 10]} className={styles.rowBox}>
          <Col span={12} className={styles.colBox}>
            <span className={styles.titleBox}>是否长尾审核：</span>
            <span className={styles.content}>{ (contentInfo as any)?.longTailReviewFlag ? '是' : '否' }</span>
          </Col>
          <Col span={12} className={styles.colBox}>
            <span className={styles.titleBox}>是否需要客户签字：</span>
            <span className={styles.content}>{ (contentInfo as any)?.customerSignFlag ? '是' : '否' }</span>
          </Col>
        </Row>
        <Row gutter={[15, 10]} className={styles.rowBox}>
          <Col span={12} className={styles.colBox}>
            <span className={styles.titleBox}>是否在线签：</span>
            <span className={styles.content}>{ (contentInfo as any)?.onlineSignFlag ? '是' : '否' }</span>
          </Col>
          <Col span={12} className={styles.colBox}>
            <span className={styles.titleBox}>是否可多次发起：</span>
            <span className={styles.content}>{ (contentInfo as any)?.startAgainFlag ? '是' : '否' }</span>
          </Col>
        </Row>
        <Row gutter={[15, 10]} className={styles.rowBox}>
          <Col span={12} className={styles.colBox}>
            <span className={styles.titleBox}>过滤数据：</span>
            <span className={styles.content}>{ (contentInfo as any)?.filterDataStr }</span>
          </Col>
          <Col span={12} className={styles.colBox}>
            <span className={styles.titleBox}>是否天猫主合同：</span>
            <span className={styles.content}>{ (contentInfo as any)?.tmallMainFlag ? '是' : '否' }</span>
          </Col>
        </Row>
        <Row gutter={[15, 10]} className={styles.rowBox}>
          <Col span={12} className={styles.colBox}>
            <span className={styles.titleBox}>是否显示：</span>
            <span className={styles.content}>{ (contentInfo as any)?.displayFlag ? '是' : '否' }</span>
          </Col>
        </Row>
      </SDrawerOrModal>
    </div>
  )
}